//import { autoListContent } from "../../routes/list-content";

export const containerCartAnimations = {
  enter: {
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
      duration: 0.1
    }
  },
  exit: {
    opacity: 0,
    transition: {
      when: "afterChildren",
      staggerChildren: 0.1,
      duration: 0.1
    }
  }
};

export const childCartAnimations = {
  exit: {
    x: -10,
    opacity: 0,
    transition: {
      duration: 0.1
    }
  },
  enter: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.1
    }
  }
};

export const checkoutAnimations = {
  exit: {
    y: 16,
    opacity: 0,
    transition: {
      duration: 0.1
    }
  },
  enter: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.1
    }
  }
};
